import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import LinearProgress from '@mui/material/LinearProgress';
import Modal from '@mui/material/Modal';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import Chip from '@mui/material/Chip';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Stack from '@mui/material/Stack';
import NorowsData from '../../../pages/General/NorowsData';
import Notification from '../../../pages/General/Notification';

import { fetchSubusersData,storeSubusersData,destorySubusersData,updateSubusersData,resetSubusersState } from './subusersSlice';

// Global enterprise layout dictionaries defining consistent forms look and feel
const enterpriseModalContainerStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '92%', sm: 600 },
    outline: 'none',
    border: 'none',
    boxSizing: 'border-box'
};

const enterpriseDeleteModalStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 420 },
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    border: '1px solid #E2E8F0',
    p: 4,
    outline: 'none',
    overflow: 'hidden'
};

const enterpriseFormInputStyles = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '10px',
        backgroundColor: '#FFFFFF',
        transition: 'all 0.2s ease-in-out',
        border: '1px solid #E2E8F0',
        '& fieldset': { border: 'none' },
        '&:hover': {
            borderColor: '#CBD5E1',
            boxShadow: '0 2px 8px rgba(0,0,0,0.02)'
        },
        '&.Mui-focused': {
            borderColor: '#1976d2',
            boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.08)'
        }
    },
    '& .MuiInputLabel-outlined': {
        color: '#64748B',
        fontWeight: 500,
        transform: 'translate(14px, 10px) scale(1)',
        '&.Mui-focused, &.MuiInputLabel-shrink': {
            transform: 'translate(14px, -8px) scale(0.75)',
            color: '#1976d2',
            fontWeight: 600
        }
    },
    '& input, & .MuiSelect-select': {
        padding: '10px 14px !important',
        fontSize: '13.5px',
        color: '#1E293B',
        fontWeight: 500
    },
    '& .MuiFormHelperText-root': {
        mx: 0.5,
        mt: 0.75,
        fontWeight: 500
    }
};

const SubUserPage = () => {
    
    const dispatch = useDispatch();
    const subusers = useSelector(state => state.subusers);
    const profile = useSelector(state => state.auth.profile);
    const [modalVisible, setModalVisible] = useState(false);
    const [deleteid, setDeleteId] = React.useState("");
    const [deleteModalopen, setDeleteModalopen] = React.useState(false);
    const [editModalopen, setEditModalopen] = React.useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [userStatus, setUserStatus] = useState("");
    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: 10,
        page: 0,
      });
    const initialValues = {
        name: '',
        email: '',
        role:'sub-user',
        source:'LABELGEN',
        status:"ACTIVE",
        stores:[]
    }
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const onModalClose = () => {
        setModalVisible(false)
        setValues(initialValues)
        setErrors({})
    }
    const validator = (fieldValues) => {
        let temp = { ...errors }
        if ('name' in fieldValues)
            temp.name = fieldValues.name ? "" : "This field is required."
        if ('email' in fieldValues)
            temp.email = fieldValues.email ? "" : "This field is required."
        if ('role' in fieldValues)
            temp.role = fieldValues.role ? "" : "This field is required."

        setErrors({
            ...temp
        })

        if (fieldValues === values)
            return Object.values(temp).every(x => x == "")
    }
    const onInputChange = e => {
        const { name, value } = e.target
        setValues({
            ...values,
            [name]: value
        })
        validator({ [name]: value })
    }
    const handleSubmit = e => {
        e.preventDefault()
        const isValid = validator(values)
        if (isValid) {
            dispatch(storeSubusersData(profile && profile.id,values))
            setModalVisible(false)
        }
    }
    
    const handleClick = (id) => {
        setDeleteId(id)
        setDeleteModalopen(true);
    };
    const deleteModalClose = () => {
        setDeleteModalopen(false);
    };
    const deleteuser = (id) => {
        dispatch(destorySubusersData(profile && profile.id,id))
        setDeleteModalopen(false);
        onModalClose()
    }

    const onEditModalClose = () => {
        setEditModalopen(false)
        setSelectedItem({})
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        if(e.target.value === "ACTIVE"){
            setUserStatus("ACTIVE")
        }else{
            setUserStatus("DELETED")
        }
    };
    const edithandleSubmit = e => {
       let finalData={
            "id":selectedItem && selectedItem.id,
            "name":selectedItem && selectedItem.name,
            "email":selectedItem && selectedItem.email,
            "status":userStatus
        }
        dispatch(updateSubusersData(profile && profile.id,finalData))
        setEditModalopen(false)
    }
    useEffect(() => {
        if (selectedItem) {
            setUserStatus(selectedItem && selectedItem.status)
        }

    }, [selectedItem]);
    const columns = [
        {
          field: 'name',
          headerName: 'Name',
          flex:1,
        },
        {
            field: 'email',
            headerName: 'Email',
            flex:1,
          },
          {
            field: 'status',
            headerName: 'Status',
            flex:1,
            renderCell: (params) => {
                if(params && params.row && params.row.status  && params.row.status==='ACTIVE' ){
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            <Chip 
                                label="ACTIVE" 
                                color="success"  
                                size="small"
                                sx={{ width: '90px', height: '24px', fontSize: '11px', fontWeight: 700 }}
                            />
                        </Box>
                    )
                }else{
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                            <Chip 
                                label="INACTIVE" 
                                color="default"  
                                size="small"
                                sx={{ width: '90px', height: '24px', fontSize: '11px', fontWeight: 700, backgroundColor: '#E2E8F0', color: '#475569' }}
                            />
                        </Box>
                    )
                }
            }
          },
          {
            field: 'last_login',
            headerName: 'Last Login on',
            flex:1,
          },
        {
          field: 'action',
          headerName: 'Action',
          flex:1,
          renderCell: (params) => {
            return (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, height: '100%' }}>
                    <Tooltip title="Edit Subuser" placement="top">
                        <IconButton
                            onClick={() => {
                                setSelectedItem(params.row);
                                setEditModalopen(true)
                            }}
                            sx={{ 
                                color: '#64748B',
                                padding: '6px',
                                borderRadius: '8px',
                                border: '1px solid #E2E8F0',
                                backgroundColor: '#FFFFFF',
                                '&:hover': { backgroundColor: '#F1F5F9', borderColor: '#CBD5E1', color: '#1E293B' }
                            }}
                        >
                            <EditIcon sx={{ fontSize: '16px' }} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete Subuser" placement="top">
                        <IconButton 
                            onClick={(e) => {
                                handleClick(params.row.id)
                            }}
                            sx={{ 
                                color: '#EF4444',
                                padding: '6px',
                                borderRadius: '8px',
                                border: '1px solid #FEE2E2',
                                backgroundColor: '#FFFFFF',
                                '&:hover': { backgroundColor: '#FEF2F2', borderColor: '#FCA5A5' }
                            }}
                        >
                            <DeleteOutlineOutlinedIcon sx={{ fontSize: '16px' }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            )
        }
        },
      ];
    useEffect(() => {
        dispatch(fetchSubusersData())
    }, [dispatch])

    return (
        <Box sx={{ width: '100%', boxSizing: 'border-box',p:2.5 }}>
         {(subusers && subusers.notification && subusers.notification.messageContent!='') &&
            <Notification
                is_open={subusers.notification.show}
                messageType={subusers.notification.messageType}
                messages={subusers.notification.messageContent}
                handleClose={() => dispatch(resetSubusersState())}
            />}
            
        {/* Modal 1: Add New Subuser Pipeline View */}
        <Modal
            open={modalVisible}
            onClose={onModalClose}
            aria-labelledby="add-user-modal-title"
            aria-describedby="add-user-modal-description"
            closeAfterTransition
        >
            <Box sx={enterpriseModalContainerStyles}>
                <Card 
                    className="sc--cardhead--details"
                    sx={{ 
                        backgroundColor: '#FFFFFF',
                        borderRadius: '16px',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                        border: '1px solid #E2E8F0',
                        overflow: 'hidden'
                    }}
                >
                    <CardHeader 
                        title={
                            <Typography id="add-user-modal-title" variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px' }}>
                                Add User
                            </Typography>
                        } 
                        action={
                            <IconButton 
                                onClick={onModalClose}
                                sx={{ 
                                    color: '#64748B',
                                    '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B' }
                                }}
                            >
                                <CloseIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                        }
                        sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                    />
                    <Divider sx={{ borderColor: '#E2E8F0' }} />
                    <CardContent sx={{ p: 3 }}>
                        <Stack spacing={2.5}>
                            <Box className="sc--form--center" sx={{ width: '100%' }}>
                                <TextField
                                    label="Name"
                                    name="name"
                                    size="small"
                                    defaultValue={values && values.name}
                                    onChange={onInputChange}
                                    error={!!errors.name}
                                    helperText={errors.name}
                                    variant="outlined"
                                    sx={enterpriseFormInputStyles}
                                />
                            </Box>
                            <Box className="sc--form--center" sx={{ width: '100%' }}>
                                <TextField
                                    label="Email"
                                    type='email'
                                    name="email"
                                    size="small"
                                    defaultValue={values && values.email}
                                    onChange={onInputChange}
                                    error={!!errors.email}
                                    helperText={errors.email}
                                    variant="outlined" 
                                    sx={enterpriseFormInputStyles}
                                />
                            </Box>
                            <Box className="sc--form--center" sx={{ width: '100%' }}>
                                <FormControl
                                    variant="outlined"
                                    size="small"
                                    error={!!errors.role}
                                    sx={enterpriseFormInputStyles}
                                >
                                    <InputLabel id="role-select-outlined-label">Role</InputLabel>
                                    <Select
                                        labelId="role-select-outlined-label"
                                        id="role-select-outlined"
                                        name="role"
                                        defaultValue={values && values.role}
                                        onChange={onInputChange}
                                        label="Role"
                                    >
                                        <MenuItem value={"sub-user"}>USER</MenuItem>
                                    </Select>
                                    {errors.role && <FormHelperText>{errors.role}</FormHelperText>}
                                </FormControl>
                            </Box>
                        </Stack>
                        
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1.5, mt: 4 }}>
                            <Button 
                                variant="outlined" 
                                onClick={onModalClose}
                                sx={{
                                    textTransform: 'none',
                                    borderRadius: '10px',
                                    fontWeight: 700,
                                    fontSize: '13.5px',
                                    height: '38px',
                                    px: 3,
                                    borderColor: '#E2E8F0',
                                    color: '#475569',
                                    '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F8FAFC', color: '#1E293B' }
                                }}
                            >
                                Cancel
                            </Button>
                            <Button 
                                variant="contained" 
                                onClick={handleSubmit}
                                sx={{
                                    textTransform: 'none',
                                    borderRadius: '10px',
                                    fontWeight: 700,
                                    fontSize: '13.5px',
                                    height: '38px',
                                    px: 4,
                                    boxShadow: 'none',
                                    backgroundColor: '#1976d2',
                                    color: '#FFFFFF',
                                    '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                }}
                            >
                                Submit
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Modal >

        {/* Modal 2: Edit Status Metrics Workflow Modifier */}
        <Modal
            open={editModalopen}
            onClose={onEditModalClose}
            aria-labelledby="edit-user-modal-title"
            aria-describedby="edit-user-modal-description"
            closeAfterTransition
        >
            <Box sx={enterpriseModalContainerStyles}>
                <Card 
                    className="sc--cardhead--details"
                    sx={{ 
                        backgroundColor: '#FFFFFF',
                        borderRadius: '16px',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                        border: '1px solid #E2E8F0',
                        overflow: 'hidden'
                    }}
                >
                    <CardHeader 
                        title={
                            <Typography id="edit-user-modal-title" variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '16px' }}>
                                Update Subuser Status
                            </Typography>
                        } 
                        action={
                            <IconButton 
                                onClick={onEditModalClose}
                                sx={{ 
                                    color: '#64748B',
                                    '&:hover': { backgroundColor: '#F1F5F9', color: '#1E293B' }
                                }}
                            >
                                <CloseIcon sx={{ fontSize: '20px' }} />
                            </IconButton>
                        }
                        sx={{ p: 2.5, backgroundColor: '#FFFFFF' }}
                    />
                    <Divider sx={{ borderColor: '#E2E8F0' }} />
                    <CardContent sx={{ p: 3 }}>
                        <Box className="sc--form--center" sx={{ width: '100%', mb: 3 }}>
                            <TextField
                                label="Email"
                                name="email"
                                size="small"
                                defaultValue={selectedItem && selectedItem.email}
                                slotProps={{
                                    input: {
                                      readOnly: true,
                                    },
                                }}
                                variant="outlined"
                                sx={{
                                    ...enterpriseFormInputStyles,
                                    '& .MuiOutlinedInput-root': {
                                        ...enterpriseFormInputStyles['& .MuiOutlinedInput-root'],
                                        backgroundColor: '#F8FAFC'
                                    }
                                }}
                            />
                        </Box>
                        <Box className="sc--form--center" sx={{ justifyContent: 'unset', pl: 0.5, mb: 1 }}>
                            <RadioGroup
                                aria-labelledby="status-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={userStatus || ""}
                                onChange={handleChange}
                                row
                                sx={{ gap: 3 }}
                            >
                                <FormControlLabel 
                                    value="ACTIVE"  
                                    control={<Radio size="small" sx={{ color: '#CBD5E1', '&.Mui-checked': { color: '#1976d2' } }} />} 
                                    label={<Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#334155' }}>ACTIVE</Typography>} 
                                />
                                <FormControlLabel 
                                    value="DELETED" 
                                    control={<Radio size="small" sx={{ color: '#CBD5E1', '&.Mui-checked': { color: '#1976d2' } }} />} 
                                    label={<Typography sx={{ fontSize: '13px', fontWeight: 600, color: '#334155' }}>INACTIVE</Typography>} 
                                />
                            </RadioGroup>
                        </Box>
                        
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1.5, mt: 3 }}>
                            <Button 
                                variant="outlined" 
                                onClick={onEditModalClose}
                                sx={{
                                    textTransform: 'none',
                                    borderRadius: '10px',
                                    fontWeight: 700,
                                    fontSize: '13.5px',
                                    height: '38px',
                                    px: 3,
                                    borderColor: '#E2E8F0',
                                    color: '#475569',
                                    '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F8FAFC', color: '#1E293B' }
                                }}
                            >
                                Cancel
                            </Button>
                            <Button 
                                variant="contained" 
                                onClick={edithandleSubmit}
                                sx={{
                                    textTransform: 'none',
                                    borderRadius: '10px',
                                    fontWeight: 700,
                                    fontSize: '13.5px',
                                    height: '38px',
                                    px: 4,
                                    boxShadow: 'none',
                                    backgroundColor: '#1976d2',
                                    color: '#FFFFFF',
                                    '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                                }}
                            >
                                Submit
                            </Button>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Modal >

        {/* Modal 3: Irreversible Entity Wipe Safe Intercept Dialog */}
        <Modal
            open={deleteModalopen}
            onClose={deleteModalClose}
            aria-labelledby="delete-confirm-modal-title"
            aria-describedby="delete-confirm-modal-description"
            closeAfterTransition
        >
            <Box sx={enterpriseDeleteModalStyles}>
                <Typography id="delete-confirm-modal-title" variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', mb: 1.5, textAlign: 'center', fontSize: '16px' }}>
                    Delete Subuser
                </Typography>
                <Typography id="delete-confirm-modal-description" variant="body2" sx={{ color: '#475569', fontWeight: 500, lineHeight: 1.6, mb: 4, textAlign: 'center' }}>
                    Are you sure want to delete this subuser?<br />This operational profile transition is irreversible.
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1.5, width: '100%' }}>
                    <Button 
                        variant="outlined" 
                        onClick={deleteModalClose}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '10px',
                            fontWeight: 700,
                            fontSize: '13.5px',
                            height: '38px',
                            px: 3.5,
                            borderColor: '#E2E8F0',
                            color: '#475569',
                            '&:hover': { borderColor: '#CBD5E1', backgroundColor: '#F8FAFC', color: '#1E293B' }
                        }}
                    >
                        No, Keep
                    </Button>
                    <Button 
                        variant="contained" 
                        onClick={() => deleteuser(deleteid)}
                        sx={{
                            textTransform: 'none',
                            borderRadius: '10px',
                            fontWeight: 700,
                            fontSize: '13.5px',
                            height: '38px',
                            px: 4.5,
                            boxShadow: 'none',
                            backgroundColor: '#EF4444',
                            color: '#FFFFFF',
                            '&:hover': { backgroundColor: '#DC2626', boxShadow: 'none' }
                        }}
                    >
                        Yes, Delete
                    </Button>
                </Box>
            </Box>
        </Modal>

        {/* Core Screen Frame Surface Panel Element */}
        <Card 
            className="scmaincard"
            sx={{ 
                width: '100%', 
                backgroundColor: '#FFFFFF',
                border: '1px solid #E2E8F0',
                borderRadius: '16px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                overflow: 'hidden'
            }}
        >
            <Box 
                className="sccardhead"
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    p: 2.5,
                    borderBottom: '1px solid #E2E8F0',
                    flexWrap: 'wrap',
                    gap: 2
                }}
            >
                <Typography 
                    variant="h5" 
                    component="h1" 
                    sx={{ 
                        fontWeight: 800, 
                        color: '#0F172A',
                        letterSpacing: '-0.5px',
                        margin: 0
                    }}
                >
                    Subusers
                </Typography>
                
                <Button 
                    variant="contained" 
                    onClick={() => { 
                         setModalVisible(true)
                         setValues(initialValues)
                     }}
                     sx={{
                        textTransform: 'none',
                        borderRadius: '10px',
                        fontWeight: 700,
                        fontSize: '13.5px',
                        height: '38px',
                        px: 3,
                        boxShadow: 'none',
                        backgroundColor: '#1976d2',
                        color: '#FFFFFF',
                        '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                     }}
                >
                    Add Subuser
                </Button>
            </Box>
            
            <Box sx={{ width: '100%', backgroundColor: '#FFFFFF' }}>
                <DataGrid
                    sx={{
                        border: 'none',
                        backgroundColor: '#FFFFFF',
                        overflow: 'hidden',
                        '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC', '&::after': { display: 'none' } },
                        '& .MuiDataGrid-columnHeaders': { backgroundColor: '#F8FAFC', borderBottom: '1px solid #E2E8F0', minHeight: '52px !important', maxHeight: '52px !important' },
                        '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '13px', '&:focus, &:focus-within': { outline: 'none' } },
                        '& .MuiDataGrid-row': { transition: 'background-color 0.15s ease-in-out', borderBottom: '1px solid #F1F5F9', alignItems: 'center', '&:hover': { backgroundColor: '#F8FAFC' } },
                        '& .MuiDataGrid-cell': { fontSize: '13.5px', color: '#334155', borderBottom: 'none', display: 'flex', alignItems: 'center', py: '12px', '&:focus, &:focus-within': { outline: 'none' } },
                        '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } },
                        '& .MuiTablePagination-root': { borderTop: '1px solid #E2E8F0', bgcolor: '#F8FAFC' }
                    }}
                    getRowId={(row) => row.id}
                    disableRowSelectionOnClick={true}
                    rows={subusers && subusers.data}
                    columns={columns}
                    autoHeight={true}
                    slots={{
                        loadingOverlay: LinearProgress,
                        noRowsOverlay: NorowsData,
                    }}
                    pageSizeOptions={[10, 20, 30]}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    loading={subusers && subusers.loading}
                />
            </Box>
        </Card>
    </Box>
    )
    
}

export default SubUserPage;